export default {
  answer: require('./portal.answer'),
  delay: require('./portal.delay'),
  like: require('./portal.like'),
  sender: require('./portal.sender'),
  spread: require('./portal.spread'),
};
